<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      服务商订单管理
      <small>/商品采购下单</small>
    </h1>
    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->
        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">供应商商品管理</h4>
              </div>
              <!-- end panel-heading -->
              <el-card class="box-card">
                <div>
                  <div class="top-hd">
                    <!-- 1 -->
                    <el-row>
                      <el-form ref="form" :model="form" label-width="90px" style="width: 80%;">
                        <el-col :span="8">
                          <div class="grid-content bg-purple-light">
                            <el-form-item label="订单号" class="btn1">
                              <el-input
                                v-model="form.orderNo"
                                placeholder="请输入订单号"
                                style="width: 90%;"
                                class="top-input"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div class="grid-content bg-purple-light">
                            <el-form-item label="商品名称" class="btn1">
                              <el-input
                                v-model="form.goodsName"
                                placeholder="请输入商品名称"
                                style="width: 90%;"
                                class="top-input"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div class="grid-content bg-purple-light">
                            <el-form-item label="订单状态 " class="btn1">
                              <el-select
                                v-model="form.barCode"
                                filterable
                                placeholder="请选择订单状态"
                                style="width: 90%;"
                                class="top-input"
                              >
                                <el-option
                                  v-for="item in status"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value"
                                ></el-option>
                              </el-select>
                            </el-form-item>
                          </div>
                        </el-col>
                      </el-form>
                    </el-row>
                    <!-- 2 -->
                  </div>

                  <div class="top-bot">
                    <el-form ref="Formdata" :model="Formdata" :rules="rules" label-width="110px">
                      <el-form-item label="订单时间 " prop="TimeValue">
                        <el-date-picker
                          v-model="Formdata.TimeValue"
                          type="datetimerange"
                          range-separator="-"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          @change="ChangePicker"
                          align="center"
                          class="top-input"
                          style="width:282px;"
                        ></el-date-picker>
                      </el-form-item>
                    </el-form>
                  </div>
                  <div class="bot-btn">
                    <a class="btn btn-primary btn-sm ButtonColor a_class" @click="chaxun()">查询</a>
                  </div>
                  <div class="right_button">
                    <el-button
                      class="btn btn-primary btn-sm ButtonColor a_class"
                      @click="addc()"
                    >新增订单</el-button>
                  </div>
                  <!-- 03 -->
                  <div class="div_tabel">
                    <el-table
                      :data="tableData3"
                      style="width: 100%"
                      size="medium"
                      border
                      :header-cell-style="{background:'#ffffff'}"
                    >
                      <el-table-column
                        width="50"
                        prop="goodsid"
                        label="序号"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        width="150"
                        prop="orderNo"
                        label="订单编号"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        width="100"
                        prop="companyName"
                        label="企业名称"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        width="100"
                        prop="recomTypeName"
                        label="客户类型"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        width="100"
                        prop="goodsName"
                        label="商品名称"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        width="100"
                        prop="orderCount"
                        label="下单数量"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        width="100"
                        prop="orderPrice"
                        label="下单金额"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        width="160"
                        prop="inputTime"
                        label="下单时间"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        width="160"
                        prop="status"
                        label="订单状态"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        width="200"
                        prop="fileUrl"
                        label="支付凭证"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      >
                        <template slot-scope="scope">
                          <div class="demo-image__preview">
                            <el-image
                              style="width: 50px; height: 50px"
                              :src="scope.row.fileUrl"
                              @click="openImg(scope.row.fileUrl)"
                            ></el-image>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column label="操作" align="center" resizable fit fixed="right">
                        <template slot-scope="scope">
                          <el-button
                            class="btn btn-primary btn-sm ButtonColor"
                            size="small"
                            @click="edit(scope.row)"
                          >编辑</el-button>
                          <el-button
                            @click="handleClick(scope.row,scope.$index+1)"
                            class="btn btn-primary btn-sm ButtonColor"
                            size="small"
                          >详情</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <!-- 04 -->
                  <div class="bottom">
                    <div class="block">
                      <el-pagination
                        :current-page="pageNo"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[10, 20, 50]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalCount"
                        background
                      ></el-pagination>
                    </div>
                  </div>
                </div>
              </el-card>
            </div>
          </div>
        </div>
      </div>
      <el-dialog title :visible.sync="outerVisible" width="500px">
        <div v-if="EditDialog === 2" class="ModelPadding">
          <div class="swal-icon swal-icon--info"></div>
          <div class="swal-title">您确定吗?</div>
          <div class="swal-text" style="text-align:center">您将无法恢复这个文件!</div>
          <div class="swal-footer">
            <div class="swal-button-container">
              <button
                class="swal-button swal-button--confirm btn btn-primary"
                @click="MakeSure"
                :disabled="disabled"
              >确定</button>
            </div>
            <div class="swal-button-container">
              <div
                class="swal-button swal-button--cancel btn btn-default"
                @click="outerVisible = false"
              >取消</div>
            </div>
          </div>
        </div>
        <!-- 审核 -->
        <div v-if="EditDialog === 4" class="ModelPadding">
          <div class="swal-title" style="margin-top:0px">{{DialogTitle}}</div>
          <div class="border-main">
            <h5>你确定保证金的金额与合同一致</h5>
          </div>
          <div slot="footer" class="dialog-footer">
            <div class="swal-button-container">
              <button
                class="swal-button swal-button--cancel btn btn-primary"
                @click="MakeSureEdit('ruleForm')"
                :disabled="disabled"
              >同意审核</button>
            </div>
            <div class="swal-button-container">
              <div
                class="swal-button swal-button--cancel btn btn-primary"
                @click="jujue('ruleForm')"
              >拒绝审核</div>
            </div>
          </div>
        </div>
      </el-dialog>

      <el-dialog title width="500px" :visible.sync="imgVisible" class="img-dialog">
        <h3>支付凭证</h3>
        <el-card :body-style="{ padding: '0px' }">
          <img :src="dialogImgUrl" width="80%" height="80%" />
        </el-card>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
import { error } from "util";
export default {
  name: "productList",
  data() {
    return {
      // 对话框
      imgVisible: false,
      dialogImgUrl: "",
      disabled: false,
      EditDialog: 1,
      outerVisible: false,
      // 当前页  ---- 默认显示第几页
      pageNo: 1,
      // 当前显示 数据的数据量
      pageSize: 10,
      // 数据总数量  ---- 总条数
      totalCount: 0,

      // 开始时间  （yyyy-MM-dd HH:mm:ss）
      startTime: "",
      // 结束时间  （yyyy-MM-dd HH:mm:ss）
      endTime: "",
      form: {
        // 商品名称
        goodsName: "",
        // 料号
        pznCode: "",
        orderNo: "",
        // 商品名称
        goodname: "",
        // 条形码
        barCode: "",
        // 服务商
        fws: "",
        //  订单类型
        listtype: ""
      },
      // 服务商名称
      recomNameList: [],
      // 订单类型选项
      typeoptions: [
        {
          value: "选项1",
          label: "TOP订单"
        },
        {
          value: "选项2",
          label: "服务商订单"
        },
        {
          value: "选项3",
          label: "分销商订单"
        }
      ],
      //  订单状态
      status: [
        {
          value: "选项1",
          label: "待财务审核"
        },
        {
          value: "选项2",
          label: "待运营审核"
        },
        {
          value: "选项3",
          label: "财务审核不通过"
        },
        {
          value: "选项4",
          label: "运营审核不通过"
        },
        {
          value: "选项5",
          label: "运营审核"
        },
        {
          value: "选项6",
          label: "财务审核"
        }
      ],
      rules: {
        TimeValue: [
          {
            required: false,
            message: "请选择查询时间",
            trigger: "change"
          }
        ]
      },
      Formdata: {
        TimeValue: ""
      },
      //   表格的 数据
      tableData3: [],
      director:0
    };
  },
  created() {},
  mounted() {
    // if(this.$route.query.director){
    //   this.director = this.$route.query.director;
    // }
    this.initData();
    this.initDatarecomNameList();
  },
  methods: {
    // 初始化数据
    initData() {
      // 短消息的  中this
      let that = this;
      const options = {
        // top订单管理
        url: "/distribution/B2cTobOrderController/queryOrderPages",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        // 请求参数
        data: Qs.stringify({})
      };
      axios(options).then(response => {
        if (response.data.code == 200) {
          for (var i = 0; i < response.data.data.records.length; i++) {
            //  goodsid  为  自定义  属性 --- 【序号】
            response.data.data.records[i].goodsid =
              Number((that.pageNo - 1) * that.pageSize) + Number(i) + 1;
          }

          for (var a of response.data.data.records) {
            if (a.orderStatus == 0) {
              a.status = "未审核";
            }
            if (a.orderStatus == 1) {
              a.status = "已审核";
            }

            if (a.recomType == 1) {
              a.recomTypeName = "分销商";
            }
            if (a.recomType == 2) {
              a.recomTypeName = "服务商";
            }
          }
          this.tableData3 = response.data.data.records;
          this.totalCount = response.data.data.total;
        } else {
          that.$notify({
            title: "失败",
            message: response.data.message,
            type: "error"
          });
        }
      });
    },
    // 服务商名称
    initDatarecomNameList() {
      let that = this;
      const options = {
        url: "/distribution/B2cRecomInfoController/getRecomInfoByCompany",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        // 请求参数
        data: Qs.stringify({
          //  运营标识：1-运营总监 2-普通运营
          director: that.director
        })
      };
      axios(options).then(response => {
        if (response.data.code == 200) {
          this.recomNameList = response.data.data;
        } else {
          that.$notify({
            title: "失败",
            message: response.data.message,
            type: "error"
          });
        }
      });
    },
    // 查询数据
    chaxun() {
      this.initData();
      // this.pageNo = 1
    },
    openImg(url) {
      if (url) {
        this.imgVisible = true;
        this.dialogImgUrl = url;
      }
    },
    addc() {
      this.$router.push({ name: "productListadd", path: "/productListadd" });
    },
    // 导出数据
    exp() {
      let that = this;
      const options = {
        url: "/distribution/B2cTobOrderController/orderExport",
        method: "get",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        params: {}
      };
      axios(options)
        .then(function(response) {
          if (response.data.code !== undefined) {
            http.handleEorrorCode(response, that);
          } else {
            that.ExportClickSecond();
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    },

    qx(item) {
      // console.log("取消");
    },
    //top订单 详情的处理函数
    handleClick(row, index) {
      this.$router.push({
        name: "topdetail",
        path: "/topdetail",
        query: {
          orderNo: row.orderNo,
          companyId: row.companyId,
          data: JSON.stringify(row)
        }
      });
    },
    // // 删除的 处理函数
    // del(item) {
    //   //console.log(row);
    //   this.outerVisible = true;
    //   this.EditDialog = 2;
    //   this.CurrentSelection = item;
    // },
    // 编辑函数
    edit(item) {
      this.$router.push({
        name: "topeidt",
        path: "/topeidt",
        query: { data: JSON.stringify(item) }
      });
    },
    export() {},
    MakeSureEdit(formName) {
      let that = this;
      if (this.DialogTitle === "审核") {
        let that = this;
        that.outerVisible = false;
        that.disabled = false;
        const options = {
          url: "/distribution/B2cTobOrderController/checkOrder",
          method: "post",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          data: Qs.stringify({
            orderStatus: 0,
            orderNo: that.ruleForm.orderNo
          })
        };
        axios(options)
          .then(function(response) {
            that.outerVisible = false;
            that.disabled = false;
            if (response.data.code == 200) {
              that.initData();
              that.$notify({
                title: "成功",
                message: "审核成功",
                type: "success"
              });
            } else {
              http.handleEorrorCode(response, that);
            }
          })
          .catch(function(error) {
            that.outerVisible = false;
            that.disabled = false;
            http.handleHttpError(error, that);
          });

        //
      }
    },
    jujue(formName) {
      this.innerVisible = true;
      // this.outerVisible = false;
      this.$prompt("理由：", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /./g,
        inputPlaceholder: "请输入拒绝审核理由",
        inputErrorMessage: "请输入拒绝审核理由"
      })
        .then(({ value }) => {
          let that = this;
          that.outerVisible = false;
          that.disabled = false;
          const options = {
            url: "/distribution/B2cTobOrderController/checkOrder",
            method: "post",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            data: Qs.stringify({
              orderStatus: 0,
              orderNo: that.ruleForm.orderNo,
              auditReason: value
            })
          };
          axios(options)
            .then(function(response) {
              that.outerVisible = false;
              that.disabled = false;
              if (response.data.code == 200) {
                that.initData();
                that.$notify({
                  title: "成功",
                  message: "拒绝审核",
                  type: "success"
                });
              } else {
                http.handleEorrorCode(response, that);
              }
            })
            .catch(function(error) {
              that.outerVisible = false;
              that.disabled = false;
              http.handleHttpError(error, that);
            });

          this.outerVisible = false;
        })
        .catch(() => {
          this.outerVisible = true;
        });
    },
    // 对话框的 【确定 】 处理函数
    MakeSure() {
      this.outerVisible = true;
    },
    getstarttime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth() + 1; //得到月份
      var date = now.getDate(); //得到日期
      //   var day = now.getDay(); //得到周几
      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒

      if (now.getMonth() + 1) {
        if (month < 10) month = "0" + (now.getMonth() + 1);
        date = "0" + "1";
        hour = "0" + "0";
        minu = "0" + "0";
        sec = "0" + "0";
      }
      var time = "";
      time =
        year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec;
      return time;
    },
    // endtime;结束时间
    getEndtime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      var day = now.getDay(); //得到周几
      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;
      var time = "";
      time =
        year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec;
      return time;
    },
    //  时间的处理函数
    ChangePicker() {
      if (this.Formdata.TimeValue !== null) {
        this.startTime = this.FormatAllDate(this.Formdata.TimeValue[0]);
        this.endTime = this.FormatAllDate(this.Formdata.TimeValue[1]);
      } else if (this.Formdata.TimeValue === null) {
        this.startTime = "";
        this.endTime = "";
      }
    },
    FormatAllDate(sDate) {
      var date = new Date(sDate);
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      //月
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      //日
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      //时
      if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
      }
      //分
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      //秒
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      //格式化后日期为：yyyy-MM-dd HH:mm:ss
      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        hours +
        seperator2 +
        minutes +
        seperator2 +
        seconds;

      return currentdate;
    },
    // 分页处理函数 分页-- 获取 每页  value条
    handleSizeChange(value) {
      this.pageSize = value;
      console.log(this.pageSize);
      this.pageNo = 1;
      this.initData();
    },
    //  获取 当前  value
    handleCurrentChange(value) {
      this.pageNo = value;
      console.log(this.pageNo);
      this.initData();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.top-input {
  margin-left: 25px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ButtonColor {
  color: #fff !important;
}
.ModelPadding {
  margin-top: -20px;
}
.LineSpacing {
  margin-top: 16px;
}
.InputWidth {
  width: 202px;
}
.top-hd {
  margin-top: 20px;
}
.text {
  font-size: 14px;
}
.div_tabel {
  margin-top: 115px;
}
.item {
  margin-bottom: 18px;
}
.right_button {
  position: absolute;
  top: 40%;
  left: 88%;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.a_class {
  padding: 8px 12px;
}
.clearfix:after {
  clear: both;
}

.box-card {
  width: 100%;
}

.bottom {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}
.bottom_table {
  display: flex;
  justify-content: flex-start;
}

.grid-content {
  border-radius: 4px;
  min-height: 20px;
}
.top-thone {
  margin-left: 20px;
  margin-top: 20px;
}
.btn1 {
  background-color: #fff;
  margin-left: 20px;
}
.bot-btn {
  float: left;
  margin-left: 3%;
}
.bot-btn-left {
  margin-left: 70px;
}
.top-bot {
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/DistributorManage/productList.vue